import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import useDelayedProgressLoader from "../hooks/useDelayedProgressLoader";
import LoaderOverlay from "./LoaderOverlay";

const LoadingOverlay = ({
    isLoading = true,
    message = "Updating, please wait...",
    zIndex = 2147483647,
    lockScroll = true,
    blur = true,
}) => {
    const [portalTarget, setPortalTarget] = useState(null);
    const { isLoaderVisible, isProgressMode, progress } =
        useDelayedProgressLoader(isLoading);

    useEffect(() => {
        if (typeof document === "undefined") return;
        setPortalTarget(document.body);
    }, []);

    useEffect(() => {
        if (!lockScroll || !isLoaderVisible || typeof document === "undefined") {
            return undefined;
        }

        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        return () => {
            document.body.style.overflow = prev;
        };
    }, [isLoaderVisible, lockScroll]);

    if (!portalTarget || !isLoaderVisible) return null;

    return createPortal(
        <LoaderOverlay
            text={message}
            mode={isProgressMode ? "progress" : "normal"}
            progress={progress}
            blur={blur}
            overlayStyle={{ zIndex, pointerEvents: "auto" }}
        />,
        portalTarget
    );
};

export default LoadingOverlay;
